import { Box, BoxProps } from "@mui/material";
import React from "react";
import styled from "styled-components";

import { WIDTH_SIZES } from "@customer-app/account/views/OperationAquarius/components/ProductImage";

interface IHiddenProductsNumberProps extends BoxProps {
  numOfHidden: number;
  isMobile: boolean;
  imageSize?: keyof typeof WIDTH_SIZES;
}

export const Wrapper = styled(Box)`
  align-items: center;
  background-color: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  bottom: 35px;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  height: 25px;
  justify-content: center;
  margin-left: 10px;
  min-width: 25px;
  padding: 4px 2px;
  position: absolute;
  right: -35px;
`;

export const HiddenProductsNumber = ({
  isMobile,
  imageSize,
  numOfHidden,
  ...props
}: IHiddenProductsNumberProps): JSX.Element => {
  return (
    <Wrapper
      // Declaring this as a span is important as it prevents this element from being hidden from item list
      component={"span"}
      sx={{
        ...(isMobile && {
          right: "-13px !important",
        }),
        ...(imageSize === "small" && {
          top: "19px",
        }),
      }}
      {...props}
    >
      +{numOfHidden}
    </Wrapper>
  );
};
